/**
 * @license
 * @copyright Copyright Motili Inc., 2021 All Rights Reserved
 */

import { ChangeEvent, ReactElement } from 'react';
import { CompanyInfo } from '../../../common/types';
import { useAppDispatch } from '../../../common/redux/hooks';
import { setCompanyInfo } from '../../../common/redux/ducks/contractorRegistrationForm';
import { styled } from 'styled-components';
import { Checkbox } from '@motili/ui';

interface UseCompanyAsBillingCheckboxProps {
    companyInfo: CompanyInfo;
}

export default function UseCompanyAsBillingCheckbox({
    companyInfo,
}: UseCompanyAsBillingCheckboxProps): ReactElement {
    const dispatch = useAppDispatch();

    const clearBillingAddressForm = (target: any) => {
        dispatch(
            setCompanyInfo({
                ...companyInfo,
                [target.name]: target.checked,
                billingAddress: {
                    address1: '',
                    address2: '',
                    city: '',
                    state: '',
                    zip: '',
                },
            })
        );
    };

    const handleCheckboxChange = (event: ChangeEvent<HTMLInputElement>) => {
        const { target } = event;
        if (!target.checked) {
            clearBillingAddressForm(target);
        } else {
            dispatch(
                setCompanyInfo({
                    ...companyInfo,
                    billingAddress: { ...companyInfo.companyAddress },
                    [target.name]: target.checked,
                })
            );
        }
    };

    return (
        <StyledCheckbox
            checked={companyInfo.useCompanyAddressAsBilling}
            label={'Use Company Address as my Billing Address'}
            onChange={handleCheckboxChange}
            name={'useCompanyAddressAsBilling'}
            value={'false'}
            id={'useCompanyAddressAsBilling'}
        />
    );
}

const StyledCheckbox = styled(Checkbox)`
    margin: 10px 0 0;
`;
